export const actionTypes = {
  show: 'LOADER_SHOW',
  hide: 'LOADER_HIDE',
  reset: 'LOADER_RESET',
}

const show = (message = '') => {
  return {
    type: actionTypes.show,
    payload: message,
  }
}

const hide = () => {
  return {
    type: actionTypes.hide,
  }
}

const reset = () => {
  return {
    type: actionTypes.reset,
  }
}

/**
 * Equivalente a tu withGlobalLoader de zustand en Katana
 */
const withGlobalLoader = (fnOrPromise, message = '') => {
  return async (dispatch) => {
    dispatch(show(message))

    try {
      const p = typeof fnOrPromise === 'function' ? fnOrPromise(dispatch) : fnOrPromise

      return await p
    } finally {
      dispatch(hide())
    }
  }
}

export const actions = {
  show,
  hide,
  reset,
  withGlobalLoader,
}
